import { ICSSInJSStyle } from "@fluentui/react-northstar";

import { useFluentColorScheme } from "../../../shared/theme/useColorScheme";
import { usePlatformTypeContext } from "../../platform-type-provider/PlatformTypeProvider";

interface ResultsHeaderStyles {
  headingLabel: ICSSInJSStyle;
  descriptionLabel: ICSSInJSStyle;
  loader: ICSSInJSStyle;
  resultsPageIndicator: ICSSInJSStyle;
}

export const useResultsHeaderStyles: () => ResultsHeaderStyles = () => {
  const { white, grey } = useFluentColorScheme();
  const { isMobile } = usePlatformTypeContext();

  const label = {
    backgroundColor: "transparent",
    color: white.foreground,
  };

  if (isMobile) {
    return {
      resultsPageIndicator: {
        color: grey.foreground2,
      },
      headingLabel: {
        ...label,
        width: "100%",
        height: "100%",
        maxWidth: "267px",
        maxHeight: "52px",
      },
      descriptionLabel: {
        ...label,
        width: "100%",
        maxWidth: "330px",
        height: "100%",
        maxHeight: "110px",
      },
      loader: {
        color: white.foreground,
      },
    };
  } else {
    return {
      resultsPageIndicator: {
        color: grey.foreground2,
      },
      headingLabel: {
        ...label,
        width: "100%",
        height: "100%",
        maxWidth: "500px",
        maxHeight: "32px",
      },
      descriptionLabel: {
        ...label,
        width: "100%",
        maxWidth: "500px",
        height: "100%",
        maxHeight: "80px",
      },
      loader: {
        color: white.foreground,
      },
    };
  }
};
